export default __webpack_public_path__ + "static/media/Software-Salas-Reuniao.f20767fa.webp";